import { Select } from '../../../../components/forms';
import { FilterWrapper } from '../../../../components/product-table/filters/filter-wrapper';
import type { ShowFilter as ShowFilterValue } from '../hooks/use-filtered-order';

const SHOW_OPTIONS: { label: string; value: ShowFilterValue }[] = [
  { label: 'All', value: 'all' },
  { label: 'Ordering', value: 'ordering' },
  { label: 'Broken cases', value: 'broken' },
];

type ShowFilterProps = {
  value: ShowFilterValue;
  onChange: (value: ShowFilterValue) => void;
};

export function ShowFilter({ value, onChange }: ShowFilterProps) {
  return (
    <FilterWrapper label="Show">
      <Select<ShowFilterValue> value={value} onChange={onChange} options={SHOW_OPTIONS} />
    </FilterWrapper>
  );
}
